import { apiRequest as request } from "../../lib/api";
export type PersonalApproval = {
  task_id: string; title: string; type: string; status: string; project_name: string;
  created_at: string; completed_at: string | null;
  report: { status: string; file_url: string | null; file_name: string | null } | null;
};
export const personalApi = {
  approvals: (all: boolean) => request<PersonalApproval[]>(`/users/me/approvals?include_completed=${all}`),
  approval: (id: string) => request<PersonalApproval>(`/users/me/approvals/${encodeURIComponent(id)}`),
  approve: (id: string) => request<PersonalApproval>(`/users/me/approvals/${encodeURIComponent(id)}/approve`, { method: "POST" })
};
